import React from 'react';
import cosmicBg from '../assets/cosmic-bg.jpg';

const CosmicBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      <div
        className="absolute inset-0 cosmic-bg-image"
        style={{ backgroundImage: `url(${cosmicBg})` }}
      />

      <div className="absolute inset-0 cosmic-bg-overlay" />
      <div className="absolute inset-0 cosmic-bg-glow" />
      <div className="absolute inset-0 cosmic-stars-layer" />
      <div className="absolute inset-0 cosmic-vignette" />
    </div>
  );
};

export default CosmicBackground;
